import { Typography, ListItemText } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';
import { pageLink } from '../utils/urls';

const Definitions = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      2. Definicje.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>2.1.</ListItemIcon>
        <ListItemText>
          <strong>Administrator</strong> - podmiot świadczący Usługi. Jest nim
          BEST S.A. z siedzibą w Gdyni przy ulicy Łużyckiej 8A, 81–537 Gdynia,
          zarejestrowana w Rejestrze Przedsiębiorców Krajowego Rejestru Sądowego
          prowadzonym przez Sąd Rejonowy Gdańsk – Północ w Gdańsku, VIII Wydział
          Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000017158,
          NIP 5850011412, REGON 190400344, o kapitale zakładowym w wysokości
          22.652.014,00 zł wpłaconym w całości. Decyzją z dnia 19.02.2010 r.,
          wydaną przez Komisję Nadzoru Finansowego na podstawie art. 192 ust. 1
          ustawy z dnia 27.05.2004 r. o funduszach inwestycyjnych i zarządzaniu
          alternatywnymi funduszami inwestycyjnymi (t.j. Dz.U. z 2021 r., poz.
          605 z późn. zm.), Administrator uzyskał zezwolenie na zarządzanie
          wierzytelnościami niestandaryzowanego funduszu inwestycyjnego.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.2.</ListItemIcon>
        <ListItemText>
          <strong>Dokument</strong> – dokumenty udostępniane przez
          Administratora na Koncie Użytkownika za pośrednictwem Serwisu, którymi
          w szczególności są:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                korespondencja wysyłana przez Administratora, tj. korespondencja
                upominawcza, wezwania do zapłaty, propozycje zawarcia ugód,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>
                korespondencja otrzymana na etapie sądowym oraz egzekucyjnym,
                tj. orzeczenia sądu, wnioski egzekucyjne oraz postanowienia
                komornika sądowego,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c)</ListItemIcon>
              <ListItemText>
                umowy, będące źródłem zobowiązania Użytkownika oraz aneksy do
                tych umów.{' '}
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.3.</ListItemIcon>
        <ListItemText>
          <strong>Hasło</strong> – indywidualne hasło utworzone przez
          Użytkownika, zabezpieczające Konto w Serwisie przed nieuprawnionym
          dostępem.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.4.</ListItemIcon>
        <ListItemText>
          <strong>Konto</strong> – konto utworzone przez Administratora po
          rejestracji przez Użytkownika w Serwisie.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.5.</ListItemIcon>
        <ListItemText>
          <strong>Login</strong> – adres e–mail Użytkownika podany podczas
          rejestracji w Serwisie.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.6.</ListItemIcon>
        <ListItemText>
          <strong>Polityka Prywatności i Cookies</strong> – dokument określony w
          pkt. 7.1 Regulaminu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.7.</ListItemIcon>
        <ListItemText>
          <strong>Regulamin</strong> – niniejszy Regulamin Serwisu BEST Online.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.8.</ListItemIcon>
        <ListItemText>
          <strong>Reklamacja</strong> – skierowane przez Użytkownika
          zastrzeżenia dotyczące Usług.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.9.</ListItemIcon>
        <ListItemText>
          <strong>Serwis</strong> – serwis BEST Online znajdujący się pod
          adresem internetowym {pageLink} i w jego podstronach.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.10.</ListItemIcon>
        <ListItemText>
          <strong>Usługi</strong> – usługi świadczone przez Administratora drogą
          elektroniczną za pośrednictwem Serwisu po akceptacji przez Użytkownika
          Regulaminu i aktywacji Konta, określone w pkt. 3.11 Regulaminu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>2.11.</ListItemIcon>
        <ListItemText>
          <strong>Użytkownik</strong> – osoba fizyczna posiadająca zobowiązanie
          pieniężne, obsługiwane przez Administratora na podstawie umów o
          zarządzanie bądź o świadczenie usług windykacyjnych, która
          zaakceptowała Regulamin oraz dokonała rejestracji i aktywacji Konta w
          Serwisie.
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default Definitions;
